export default "__VITE_ASSET__BG6J5Xl2__"